<template>

    <div>
        <el-row>
            <el-col :span="24">
                <div class="grid-content bg-purple-light">

                    <div class="searchTitle">
                        <b style="font-size: 20px !important;"> 출고매핑  </b>
                    </div>

                    <!-- 조회 조건 영역 -->
                    <div class="searchBody">
                        <!-- 조회 조건 영역 -->

                        <div class="searchBody_year" style="font-size: 15px !important;">
                            작업 일자
                        </div>
                        <div style="margin-left: 10px">
                            <el-date-picker
                                    v-model="confirmStartDateOption"
                                    type="date"
                                    placeholder="Pick a day"
                                    value-format="yyyy-MM-dd"
                                    class="date-input"
                            >
                            </el-date-picker>
                            ~
                            <el-date-picker
                                    v-model="confirmEndDateOption"
                                    type="date"
                                    placeholder="Pick a day"
                                    value-format="yyyy-MM-dd"
                                    class="date-input"
                            >
                            </el-date-picker>
                        </div>
                    </div>


                    <div class="searchBody">
                        <!-- 조회 조건 영역 -->
                        <div class="searchBody_year" style="font-size: 15px !important;">
                            품목 :
                        </div>
                        <div   style="margin-left: 10px;" >
                            <el-select
                                v-model="countryInput"
                                :loading="loading"
                                @change="handleSelectChange"
                                size="small"
                                placeholder="품목 선택"
                            >
                                <el-option
                                    v-for="item in itemOptions"
                                    :key="item.value"
                                    :label="item.label"
                                    :value="item.value"
                                />
                            </el-select>

                            <el-button
                                v-if="countryInput"
                                icon="el-icon-refresh-left"
                                size="mini"
                                circle
                                class="reset-btn"
                                @click="countryInput=''"
                                title="초기화"
                            ></el-button>
                        </div>
                    </div>


                    <div class="searchBody">
                        <!-- 조회 조건 영역 -->
                        <div class="searchBody_year" style="font-size: 15px !important;">
                            BOX BARCODE :
                        </div>
                        <div >
                            <el-input
                                    placeholder=""
                                    v-model="letNoInput"
                                    class="wide-input"
                                    style="margin-left: 10px;"
                            >
                            </el-input>
                        </div>
                    </div>

                    <div class="searchBody">
                        <!-- 조회 조건 영역 -->
                        <div class="searchBody_year" style="font-size: 15px !important;">
                            QR CODE :
                        </div>
                        <div >
                            <el-input
                                placeholder=""
                                v-model="barcodeInput"
                                style="margin-left: 10px; width: 380px!important;"
                            >
                            </el-input>
                        </div>
                    </div>




                    <div class="searchBody"            >
                        <div class="searchBody_brand">
                            <el-button
                                    :loading="loading"
                                    type="primary"
                                    @click="search"
                            >Search</el-button>
                        </div>
                    </div>


                </div> <!-- div class="grid-content bg-purple-light"> -->
            </el-col>

        </el-row>

        <el-row>
            <el-col :span="20">
                <div class="grid-content bg-purple-light" >

                    <el-table
                            v-loading="loading"
                            ref="multipleTable"
                            :data="tableData"

                            border
                            @selection-change="handleSelectionChange"
                            :row-class-name="tableRowClassName"
                            size="small"
                            :row-style="{ height: 0 + 'px' }"
                            :cell-style="{ padding: 0 + 'px' }"
                            :header-cell-style="{
                          background: '#2F384E',
                          color: '#fff',
                          height: '10px',
                          padding: '0px',
                        }"
                    >
                        <el-table-column
                                type="selection"
                                width="35"
                        >
                        </el-table-column>

                        <!-- data 시작 -->
                        <!-- <el-table-column
                          label="Date"
                          width="120">
                          <template slot-scope="scope">{{ scope.row.date }}</template>
                        </el-table-column> -->

                        <el-table-column
                                property="seq"
                                label="일련번호"
                                width="80">
                        </el-table-column>


                        <el-table-column label="작업시간" width="180">
                            <template #default="scope">
                                {{ scope.row.insert_date_ktng ? scope.row.insert_date_ktng.substring(0, 16) : '' }}
                            </template>
                        </el-table-column>


                        <el-table-column
                            property="country"
                            label="품목"
                            width="200">
                        </el-table-column>




                        <el-table-column
                                property="letNo"
                                label="BOX BARCODE"
                                width="330">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click="handleClick1(scope.row.letNo,scope.row.insert_date_ktng, scope.row.country ) " >
                                    {{scope.row.letNo}}</el-button>
                            </template>
                        </el-table-column>



                        <el-table-column
                                property="count"
                                label="건수"
                                width="150">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click="handleClick1(scope.row.letNo,scope.row.insert_date_ktng, scope.row.country ) " >
                                    {{scope.row.count}}</el-button>
                            </template>
                        </el-table-column>
                    </el-table>




                    <el-row>
                        <el-col :span="24"><div class="pagination"  >

                            <el-pagination
                                    small
                                    layout="prev, pager, next"
                                    :total="totalSize"
                                    @size-change="handleSizeChange"
                                    @current-change="handleCurrentChange"
                                    :current-page.sync="currentPage"
                                    :page-size="pageSize"
                            >
                            </el-pagination>



                            <el-button
                                    :loading="loading"
                                    type="primary"
                                    @click="prepareFailSound(); dialogVisible2 = true; barcode = ''; pop2 = true; selectedAmount = 0; itemData = '';"
                            >박스매핑</el-button>


                            <el-button
                                    :loading="loading"
                                    type="primary"
                                    @click="handleDelete"
                            >삭제</el-button>


                            <el-button
                                    :loading="loading"
                                    type="primary"
                                    @click="excelDownFuncAll"
                                    style="margin-left: 10px"
                            > 엑셀 다운로드 </el-button>

                            <el-tag type="warning" effect="dark"  style="margin-left: 10px; height: 30px"> TOTAL COUNT : {{this.totalData.length}}</el-tag>
                        </div>
                        </el-col>
                    </el-row>


                                        <el-dialog
                                                title="     박스매핑"
                                                :visible.sync="dialogVisible2"
                                                width="96vw"
                                                top="0.5vh"
                                                v-loading="loading"
                                                :before-close="Confirm2"
                                                :close-on-click-modal="false"
                                                custom-class="rounded-dialog box-mapping-dialog"
                                        >

                                            <el-row>
                                                <el-col >
                                                    <div style="margin-top: 0px; margin-left: 20px; display: flex; align-items: center;">
                                                        <!-- '품목' 글자와 셀렉트 박스 사이 간격을 위해 span으로 감싸고 여백을 줍니다 -->
                                                        <span style="margin-right: 10px; font-size: 20px !important;">*품목 :</span>

                                                        <el-select
                                                            v-model="itemData"
                                                            :loading="loading"
                                                            @change="handleSelectChange"
                                                            size="small"

                                                            placeholder="품목 선택"
                                                        >
                                                            <el-option
                                                                v-for="item in itemOptions"
                                                                :key="item.value"
                                                                :label="item.label"
                                                                :value="item.value"
                                                            />
                                                        </el-select>

                                                        <!-- 옆으로 붙이기 위해 div 대신 span을 쓰거나, 왼쪽 여백(margin-left)을 줍니다 -->
                                                        <div
                                                            :class="['qr-count', isValid ? 'text-blue' : 'text-red']"
                                                            style="margin-left: 15px; font-weight: bold;"
                                                        >
                                                            선택된 수량: {{ selectedAmount }}
                                                        </div>
                                                    </div>
                                                </el-col>
                                            </el-row>

                                            <el-row>
                                                <el-col >
                                                    <div style="margin-top: 0px">

                                                        <el-input
                                                                id="textarea_class"
                                                                class="textarea_class"
                                                                type="textarea" v-model="barcode"
                                                                :rows="10"
                                                                placeholder="QR 코드를 스캔하세요"
                                                                lang="en"
                                                                inputmode="url"
                                                                autocorrect="off"
                                                                autocapitalize="off"
                                                                spellcheck="false"
                                                        ></el-input>
                                                    </div>
                                                </el-col>
                                            </el-row>
                                            <el-row>
                                                <el-col >
                                                    <div style="margin-top: 1px">
                                                        <div :class="['qr-count', isValid ? 'text-blue' : 'text-red']">
                                                            리딩된 QR COUNT : {{ qrCount }}
                                                        </div>
                                                        <!-- 선택된 금액 표시 -->
                                                            <el-checkbox type="primary"   v-model="autoSave">자동 저장</el-checkbox>
                                                            <el-button type="primary" @click="qrSave">등록 </el-button>
                                                        </div>
                                                </el-col>
                                            </el-row>

                    </el-dialog>



                        <el-dialog
                            title="수정"
                            :visible.sync="dialogVisible3"
                            width="96vw"
                            top="0.5vh"
                            v-loading="loading"
                            :before-close="Confirm2"
                            :close-on-click-modal="false"
                            custom-class="rounded-dialog box-mapping-dialog"
                        >

                            <el-row>
                                <el-col >
                                    <div style="margin-top: 0px; margin-left: 0px; display: flex; align-items: center;">
                                        <!-- '품목' 글자와 셀렉트 박스 사이 간격을 위해 span으로 감싸고 여백을 줍니다 -->
                                        <span style="margin-right: 10px; font-size: 20px !important;">*품목 :</span>

                                        <el-select
                                            v-model="itemData2"
                                            :loading="loading"
                                            @change="handleSelectChange"
                                            placeholder="선택"
                                        >
                                            <el-option
                                                v-for="item in itemOptions"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value"
                                            />
                                        </el-select>

                                        <!-- 옆으로 붙이기 위해 div 대신 span을 쓰거나, 왼쪽 여백(margin-left)을 줍니다 -->
                                        <div
                                            :class="['qr-count', isValid ? 'text-blue' : 'text-red']"
                                            style="margin-left: 20px; font-weight: bold;"
                                        >
                                            선택된 수량: {{ selectedAmount }}
                                        </div>
                                    </div>
                                </el-col>
                            </el-row>

                        <el-row>
                            <el-col >
                                <div style="margin-left: 0px; display: flex; align-items: center; margin-bottom: 10px;">

                                    <span style="font-size: 20px !important;">BOX NO :</span>

                                    <el-input
                                        style="margin-left: 5px"
                                        placeholder=""
                                        v-model="letNo2"
                                        :style="{ width: '250px' }"
                                        class="inputBarcode"
                                    >
                                    </el-input>


                                </div>

                                <div style="margin-top: 0px;">
                                    <el-input
                                        id="textarea_class"
                                        class="textarea_class"
                                        type="textarea" v-model="barcode"
                                        :rows="10"
                                        placeholder="QR 코드를 스캔하세요"
                                        lang="en"
                                        inputmode="url"
                                        autocorrect="off"
                                        autocapitalize="off"
                                        spellcheck="false"
                                    ></el-input>

                                </div>
                            </el-col>
                        </el-row>


                            <el-row>
                                <el-col >
                                    <div style="margin-top: 1px">
                                        <div :class="['qr-count', isValid ? 'text-blue' : 'text-red']">
                                            리딩된 QR COUNT : {{ qrCount }}
                                        </div>
                                        <el-button type="primary" @click="handleUpdate()">수정 </el-button>
                                    </div>
                                </el-col>
                            </el-row>



                    </el-dialog>




                </div>
            </el-col>
        </el-row>

    </div>
</template>


<script>
import Axios from 'axios';
import XLSX from "xlsx";


export default {
    created() {
        this.$store.commit("dayBefore",0);
        this.confirmEndDateOption = this.$store.state.dateOption; // 조회조건에서 현재 날짜
        this.$store.commit("dayBefore",7);
        this.confirmStartDateOption = this.$store.state.dateOption; // 조회조건이서 현재보다 -7 일
        if (this.$store.state.userId != 'admin') {
            // this.deptSeqOption = this.$store.state.deptSeq;
            // this.deptNameOption = this.$store.state.deptName;
        }

        // console.log()
        // 페이지로딩시 조회
        this.search();
        this.itemGetList();
        // this.getFilePath();
    },//created
    computed: {
        qrCount() {
            if (!this.barcode) return 0;

            // 민오님의 QR 코드 고정 길이 (예시 URL 기준 42자)
            const FIXED_LENGTH = 42;

            return this.barcode.split('\n').filter(line => {
                const trimmed = line.trim();
                // 1. 공백이 아니어야 함
                // 2. http로 시작해야 함
                // 3. 길이가 정확히 FIXED_LENGTH와 일치해야 함
                return trimmed !== '' &&
                    trimmed.startsWith('http') &&
                    trimmed.length === FIXED_LENGTH;
            }).length;
        },

        isValid() {
            // qrCount가 목표 개수(selectedAmount)와 정확히 일치할 때만 true
            return this.qrCount > 0 && this.qrCount === this.selectedAmount;
        }
    },

    watch: {
        barcode(newValue) {
            if (this.isRemovingDuplicateBarcode) {
                this.isRemovingDuplicateBarcode = false;
                return;
            }

            const duplicateInfo = this.findDuplicateInfo((newValue || '').split('\n'));

            if (!duplicateInfo.value) {
                this.lastDuplicateValue = '';
                this.lastDuplicateCount = 0;
                return;
            }

            if (this.lastDuplicateValue !== duplicateInfo.value || this.lastDuplicateCount !== duplicateInfo.count) {
                this.lastDuplicateValue = duplicateInfo.value;
                this.lastDuplicateCount = duplicateInfo.count;
                this.playFailSound();
                this.$message.error(`이미 중복된 값이 있습니다: ${duplicateInfo.value}`);

                const nextBarcode = this.removeDuplicateLines(newValue || '');
                if (nextBarcode !== newValue) {
                    this.isRemovingDuplicateBarcode = true;
                    this.barcode = nextBarcode;
                    this.lastDuplicateValue = '';
                    this.lastDuplicateCount = 0;
                }
            }
        },

        qrCount(newCount) {
            console.log("현재 유효 QR 개수:", newCount);

            // 고정 길이 체크 덕분에 중간에 'http'만 입력될 때는 newCount가 변하지 않습니다.
            // 정확히 한 줄이 완성되어 42자가 되는 순간에만 newCount가 증가합니다.
            if (newCount > 0 && newCount === this.selectedAmount) {
                if (this.autoSave && this.pop2) {
                    if (this.findDuplicateValue((this.barcode || '').split('\n'))) {
                        return;
                    }
                    console.log(this.selectedAmount + "개 완벽하게 인식됨! 저장을 실행합니다.");
                    this.qrSave();
                }
            }
        }
    },

    data() {
        return {
            failAudioContext: null,
            // table 관련 data
            tableData: [],
            totalData: [],
            totalData2: [],
            tableData2:[],
            multipleSelection: [],
            multipleTable2 :[],
            itemData: "",
            itemData2 : "",
            saveData:[],
            saveData2:[],
            currentPage: 1,
            pageSize:10,
            totalSize:0,

            // loading 변수 true 이면 loging 화면 보여줌
            loading:false,

            statusOptions: [{

                value: 'I',
                label: '입고'
            },
                {
                    value: 'O',
                    label: '출고'
                }, ],
            brandOption: '',
            styleOption :'',
            deptNameOption:'',
            deptSeqOption:0,
            confirmStartDateOption:'',
            confirmEndDateOption:'',
            statusOption:'입고',
            status:'',
            fileList: [],
            text :[],
            dialogVisible: false,
            dialogVisible2:false,
            dialogVisible3:false,
            statusLavel:'',
            filePath:'',
            epc :'',
            member_id :'',
            member_name : '',
            chkOutDate : false,
            items : [],
            excelJsonData :  [],
            barcode : '',
            barcode2 : '',
            inputQrCode : '',
            inputBigQrCode : '',
            countFlag:'All',
            waybill_number : '',
            big_qr_code : '',
            inPutFlag : 0,
            autoSave  : true,
            inputWayBillNumber :'',
            countryInput :'',
            storeInput :'',
            bigoInput :'',
            barcodeInput :'',
            store :'',
            country :'',
            bigo : '',
            countrys : [],
            stores : [],
            tmpStore : [],
            editCountry : '',
            editStore : '',
            editInsertDate : '',
            letNo2 : '',
            auth_store_barcode_info_seq : [],
            insert_date_ktng : '',
            insert_date_ktng2 : '',
            itemOptions: [],
            deptOptions: [],
            itemStoreInfoSeq : [],
            itemValue: [],
            itemList: [],
            itemStates: [],
            selectedAmount : 0,
            selectedItemStoreInfoSeq : 0,
            pop2 : true,
            letNoInput : '',
            itemDataInput : '',
            lastDuplicateValue: '',
            lastDuplicateCount: 0,
            isRemovingDuplicateBarcode: false,

        } // return
    },// data

    methods: {

        handleSelectChange(val) {
            // itemStates에서 선택된 값의 인덱스를 찾음
            const index = this.itemStates.indexOf(val);
            if (index !== -1) {
                // 동일한 인덱스의 amount를 가져옴
                this.selectedAmount = this.itemValue[index];
                this.selectedItemStoreInfoSeq   = this.itemStoreInfoSeq[index];
            }
        },

        async itemGetList() {

            let url = this.$url + '/authStoreInfo/list';
            var reqJson = new Object();
            reqJson.user_seq = 173;

            await Axios.post(url, reqJson, this.$store.state.config)
                .then((res) => {
                    var resDataJson = res.data.authStoreInfoDTO;

                    console.log("=tt=t");
                    console.log(resDataJson);

                    this.itemStates = [];
                    this.itemList = [];
                    this.itemOptions = [];
                    this.itemStoreInfoSeq = [];

                    if (res.data.resultCode) {
                        for (var resData in resDataJson) {
                            this.itemStates[resData] = resDataJson[resData]["country"].trim();
                            this.itemValue[resData] = resDataJson[resData]["amount"];
                            this.itemStoreInfoSeq[resData] = resDataJson[resData]["auth_store_info_seq"];
                        }
                        this.loading = false;

                        this.itemList = this.itemStates.map((item, index) => {
                            return {
                                value: item,
                                label: item,
                                amount: this.itemValue[index],
                                itemStoreInfoSeq : this.itemStoreInfoSeq[index]
                            };
                        });

                        this.itemOptions = this.itemList;
                    } else {
                        this.$notify.error({
                            title: this.$store.state.dataNotFound,
                            position: "bottom-right",
                            duration: 1500,
                        });
                        this.currentPage = 1;
                        this.loading = false;
                    }
                }) // await Axios.post
                .catch((error) => {
                    console.log(error.response);
                    this.$notify.error({
                        title: this.$store.state.serverErrorMessage,
                        position: "bottom-right",
                        duration: 1500,
                    });
                    this.currentPage = 1;
                    this.loading = false;
                }); // await Axios.post
        }, //search

        inputChange(event){

            if (this.autoSave) {

                 {


                    if (event.length >= 12  ) {

                        if (event.substr(-1) == '\n') {

                            var tmp = event.replace(/\n/g, "");

                            var num = Number(tmp.substr(tmp.length - 18, 18));

                            console.log ( tmp.substr(tmp.length - 18, 18) )
                            console.log ( num )

                            if (isNaN(num)) {
                                console.log(Number(event.substr(tmp.length - 18, 12) ))

                            }else {

                                // if (event.substr(event.length - 14, 1) != '=') {
                                this.qrSave();
                                this.qrcode = "";
                                // }
                            }
                        }
                    }
                }

                if (event.substr(-1) == '\n') {
                    this.tmpData = ''
                }else{
                    this.tmpData =  this.tmpData + event.substr(-1)
                }
            }
        },


        handleClick1(lotNo, insert_date_ktng, country   ){
            console.log( "----------------------") ;
            console.log( lotNo) ;
            console.log( insert_date_ktng) ;

            console.log( "----------------------") ;
            this.search4(lotNo, insert_date_ktng, country   );
        },




        handleCheckedChange() {

            this.tmpStore=[];

            for (var resData in this.stores) {

                if (this.country == this.stores[resData]['country'] ) {

                    this.tmpStore.push({
                        seq: resData * 1 + 1
                        , country: this.stores[resData]['country']
                        , store: this.stores[resData]['store']

                    });
                }
            }
        },



        async search4(letNo, insert_date_ktng, country) {
            // default data
            let url = this.$url + '/authStoreBarcodeInfo/getBarcode';
            var reqJson = new Object();
            reqJson.letNo = letNo
            reqJson.user_seq = 173;
            reqJson.insert_date_ktng  = insert_date_ktng;
            this.insert_date_ktng = insert_date_ktng;

            this.letNo2 = letNo;
            this.loading = true;
            this.auth_store_barcode_info = [];
            this.barcode = '';

            this.itemData2 = country;
            this.pop2 = false;

            if (this.itemData2 === null || this.itemData2.trim() ==='')
            {
                this.selectedAmount = 0;
                console.log("test : " + this.itemData2)

            }else {

                const selectedItem = this.itemList.find(item => item.value === this.itemData2);

                console.log("test : " + this.itemData2)
                console.log("test : " + selectedItem.amount)
                console.log("test : " + selectedItem.itemStoreInfoSeq)

                if (selectedItem) {
                    const amount = selectedItem.amount;
                    const itemStoreInfoSeq = selectedItem.itemStoreInfoSeq;
                    this.selectedAmount = amount;
                    this.selectedItemStoreInfoSeq = itemStoreInfoSeq;
                    this.qrCount = this.selectedAmount;

                } else {
                    console.log("해당하는 값을 찾을 수 없습니다.");
                }
            }

            this.qrCount = 0;

            await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
                var resDataJson = res.data.authStoreBarcodeInfoDTO;

                if (res.data.resultCode) {
                    for (var resData in resDataJson) {
                        this.barcode =  this.barcode + resDataJson[resData]['barcode'] + '\n' ;
                        this.auth_store_barcode_info_seq[resData] = resDataJson[resData]['auth_store_barcode_info_seq'];
                        // this.insert_date_ktng = resDataJson[resData]['insert_date_ktng']
                        this.qrCount  =  this.qrCount + resData;
                    }
                }

                this.loading = false;
                this.dialogVisible3 = true;

            }) // await Axios.post
                .catch(error => {
                    console.log(error.response)
                    this.$message.error(this.$store.state.serverErrorMessage);
                    this.loading = false;
                }); // await Axios.post
        },//


        async search(){
            this.loading = true;

            // default data
            let url = this.$url + '/authStoreBarcodeInfo/list2';
            var reqJson = new Object();

            reqJson.in_start_date = this.confirmStartDateOption;
            reqJson.in_end_date = this.confirmEndDateOption;
            reqJson.country = this.countryInput;
            reqJson.letNo = this.letNoInput;
            reqJson.barcode = this.barcodeInput.replace(/\s+/g, '');
            reqJson.user_seq = 173;


            await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
                var resDataJson = res.data.authStoreBarcodeInfoDTO;
                this.totalData=[];

                if (res.data.resultCode){

                    for (var resData in resDataJson) {

                        this.totalData.push({
                            seq: resData  * 1 + 1
                            , insert_date : resDataJson[resData]['insert_date']
                            , letNo : resDataJson[resData]['letNo']
                            , store : resDataJson[resData]['store']
                            , count : resDataJson[resData]['count']
                            , user_seq : resDataJson[resData]['user_seq']
                            , auth_store_barcode_info_seq :  resDataJson[resData]['auth_store_barcode_info_seq']
                            , insert_date_ktng : resDataJson[resData]['insert_date_ktng']
                            , country:  resDataJson[resData]['country']
                        });

                    }
                    // 전체 데이터 사이즈
                    this.totalSize = this.totalData.length;
                    // 보여주는 부분만 slice
                    this.tableData = this.totalData.slice(0, this.pageSize);
                    this.currentPage = 1;
                    this.loading = false;
                    this.status = reqJson.status;
                    this.$message.success(this.$store.state.searchSuccess);
                }else{
                    this.$message.error(this.$store.state.dataNotFound);
                    this.currentPage = 1;
                    this.loading = false;
                }
            }) // await Axios.post
                .catch(error => {
                    console.log(error.response)
                    this.$message.error(this.$store.state.serverErrorMessage);
                    this.currentPage = 1;
                    this.loading = false;
                }); // await Axios.post
        },//search

        toggleSelection(rows) {
            if (rows) {
                rows.forEach(row => {
                    this.$refs.multipleTable.toggleRowSelection(row);
                });
            } else {
                this.$refs.multipleTable.clearSelection();
            }
        }, //toggleSelection

        // check box click event
        handleSelectionChange(val) {
            this.multipleSelection = val;
        },
        tableRowClassName({row, rowIndex}) {
            if (rowIndex === 1) {
                //  return 'warning-row';
            } else if (rowIndex === 3) {
                //  return 'success-row';
            }
            console.log(row);
            return '';
        },
        handleSizeChange(val) {
            console.log(`${val} items per page`);
        },

        // pagging event
        handleCurrentChange(val) {
            this.tableData = this.totalData.slice( (this.pageSize * val - this.pageSize )   , this.pageSize * val);
        },
        //
        // async excelDownFunc(){
        //
        //   if(this.multipleSelection==null || this.multipleSelection.length == 0 ){
        //     this.$message.error(this.$store.state.noDataSelect);
        //     return ;
        //   }
        //
        //   this.loading = true;
        //
        //   // default data
        //   let url = this.$url + '/rfidInfo/reDowload';
        //   // var reqJson = new Object();
        //
        //   await Axios.post(url, this.multipleSelection , this.$store.state.config ).then(res => {
        //     let saveCount = res.data;
        //
        //
        //     if (saveCount){
        //       this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
        //       this.loading = false;
        //
        //     }else{
        //       this.$message.error(this.$store.state.serverErrorMessage);
        //       this.currentPage = 1;
        //       this.loading = false;
        //     }
        //   }) // await Axios.post
        //       .catch(error => {
        //         console.log(error.response)
        //         this.$message.error(this.$store.state.serverErrorMessage);
        //         this.currentPage = 1;
        //         this.loading = false;
        //       }); // await Axios.post
        //
        //
        // }, //excelDownFunc



        async pathUpload(){


            this.loading = true;

            // default data
            let url = this.$url + '/saveInfo/pathUpdate';
            var reqJson = new Object();


            reqJson.file_full_path = this.filePath;

            await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
                let saveCount = res.data;

                if (saveCount){
                    this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
                    this.loading = false;

                }else{
                    this.$message.error(this.$store.state.serverErrorMessage);
                    this.currentPage = 1;
                    this.loading = false;
                }
            }) // await Axios.post
                .catch(error => {
                    console.log(error.response)
                    this.$message.error(this.$store.state.serverErrorMessage);
                    this.currentPage = 1;
                    this.loading = false;
                }); // await Axios.post


        }, //excelDownFunc

        getCheckSum(hex)
        {
            var chk = hex.length
            var value = 0;
            for(var i=0; i <hex.length; i += 2) {
                value +=  parseInt(hex.substring(i, i+2),16) * chk
                chk ++;
            }
            var res = value * 1224 % 100;
            if (res <= 9)
                return '0' + res;
            else
                return res;
        },

        convertToHex(str) {
            var hex = '';
            for(var i=0;i<str.length;i++) {
                hex += str.charCodeAt(i).toString(16);
            }
            return hex;
        },

        convertToString(hex) {

            //console.log("convertToString");
            //console.log(hex);

            var str = '';
            for(var i=0;i<hex.length; i += 2) {
                str += String.fromCharCode(parseInt(hex.substring(i, i+2),16))
            }
            return str;
        },

        filesChange(event) {
            // get File object from input tag
            this.loading = true;

            const file = event.target.files[0];
            let reader = new FileReader();
            let tmpResult = {};
            reader.onload = (e) => {

                console.log(e);

                let data = reader.result;
                let workbook = XLSX.read(data, {type: 'binary'});
                workbook.SheetNames.forEach(sheetName => {
                    workbook.Sheets[sheetName].A1.w = "region";
                    workbook.Sheets[sheetName].B1.w = "waybill_number";
                    workbook.Sheets[sheetName].C1.w = "sender";
                    workbook.Sheets[sheetName].D1.w = "sender_hp";

                    workbook.Sheets[sheetName].E1.w = "sender_manager";
                    workbook.Sheets[sheetName].F1.w = "sender_manager_hp";
                    workbook.Sheets[sheetName].G1.w = "sender_zip_code";
                    workbook.Sheets[sheetName].H1.w = "sender_address";

                    workbook.Sheets[sheetName].I1.w = "receiver";
                    workbook.Sheets[sheetName].J1.w = "receiver_hp";
                    workbook.Sheets[sheetName].K1.w = "receiver_manager";
                    workbook.Sheets[sheetName].L1.w = "receiver_manager_hp";

                    workbook.Sheets[sheetName].M1.w = "receiver_zip_code";
                    workbook.Sheets[sheetName].N1.w = "receiver_address";
                    workbook.Sheets[sheetName].O1.w = "fare_type";

                    workbook.Sheets[sheetName].P1.w = "payment_type";
                    workbook.Sheets[sheetName].Q1.w = "release_number";


                    workbook.Sheets[sheetName].R1.w = "remark";

                    workbook.Sheets[sheetName].S1.w = "memo1";
                    workbook.Sheets[sheetName].T1.w = "memo2";

                    workbook.Sheets[sheetName].U1.w = "memo3";
                    workbook.Sheets[sheetName].V1.w = "memo4";

                    workbook.Sheets[sheetName].W1.w = "lbl_hub_code";
                    workbook.Sheets[sheetName].X1.w = "product_name1";
                    workbook.Sheets[sheetName].Y1.w = "product_count1";


                    workbook.Sheets[sheetName].Z1.w = "product_name2";
                    workbook.Sheets[sheetName].AA1.w = "product_count2";
                    workbook.Sheets[sheetName].AB1.w = "product_name3";
                    workbook.Sheets[sheetName].AC1.w = "product_count3";


                    workbook.Sheets[sheetName].AD1.w = "product_name4";
                    workbook.Sheets[sheetName].AE1.w = "product_count4";
                    workbook.Sheets[sheetName].AF1.w = "product_name5";
                    workbook.Sheets[sheetName].AG1.w = "product_count5";

                    workbook.Sheets[sheetName].AH1.w = "product_name6";
                    workbook.Sheets[sheetName].AI1.w = "product_count6";
                    workbook.Sheets[sheetName].AJ1.w = "product_name7";
                    workbook.Sheets[sheetName].AK1.w = "product_count7";



                    workbook.Sheets[sheetName].AL1.w = "product_name8";
                    workbook.Sheets[sheetName].AM1.w = "product_count8";

                    workbook.Sheets[sheetName].AN1.w = "product_name9";


                    workbook.Sheets[sheetName].AO1.w = "product_count9";
                    workbook.Sheets[sheetName].AP1.w = "product_name10";
                    workbook.Sheets[sheetName].AQ1.w = "product_count10";
                    workbook.Sheets[sheetName].AR1.w = "product_name11";


                    workbook.Sheets[sheetName].AS1.w = "product_count11";
                    workbook.Sheets[sheetName].AT1.w = "product_name12";


                    workbook.Sheets[sheetName].AU1.w = "product_count12";


                    workbook.Sheets[sheetName].AV1.w = "product_name13";


                    workbook.Sheets[sheetName].AW1.w = "product_count13";
                    workbook.Sheets[sheetName].AX1.w = "product_name14";
                    workbook.Sheets[sheetName].AY1.w = "product_count14";
                    workbook.Sheets[sheetName].AZ1.w = "product_name15";




                    workbook.Sheets[sheetName].BA1.w = "product_count15";
                    workbook.Sheets[sheetName].BB1.w = "product_name16";
                    workbook.Sheets[sheetName].BC1.w = "product_count16";
                    workbook.Sheets[sheetName].BD1.w = "product_name17";
                    workbook.Sheets[sheetName].BE1.w = "product_count17";
                    workbook.Sheets[sheetName].BF1.w = "product_name18";


                    workbook.Sheets[sheetName].BG1.w = "product_count18";
                    workbook.Sheets[sheetName].BH1.w = "product_name19";
                    workbook.Sheets[sheetName].BI1.w = "product_count19";
                    workbook.Sheets[sheetName].BJ1.w = "product_name20";


                    workbook.Sheets[sheetName].BK1.w = "product_count20";
                    workbook.Sheets[sheetName].BL1.w = "product_name21";
                    workbook.Sheets[sheetName].BM1.w = "product_count21";
                    workbook.Sheets[sheetName].BN1.w = "product_name22";


                    workbook.Sheets[sheetName].BO1.w = "product_count22";
                    workbook.Sheets[sheetName].BP1.w = "product_name23";
                    workbook.Sheets[sheetName].BQ1.w = "product_count23";


                    workbook.Sheets[sheetName].BR1.w = "product_name24";
                    workbook.Sheets[sheetName].BS1.w = "product_count24";
                    workbook.Sheets[sheetName].BT1.w = "product_name25";
                    workbook.Sheets[sheetName].BU1.w = "product_count25";


                    workbook.Sheets[sheetName].BV1.w = "product_name26";
                    workbook.Sheets[sheetName].BW1.w = "product_count26";


                    //console.log(workbook.Sheets[sheetName].A1);
                    const roa = XLSX.utils.sheet_to_json(workbook.Sheets[sheetName]);
                    tmpResult = roa;
                });

                //console.log("=====================================");
                //console.log(tmpResult);
                this.excelJsonData=tmpResult;


                let url = "";
                url = this.$url + '/claWayBillInfo/insert';

                Axios.post(url, this.excelJsonData , this.$store.state.config  ).then(res => {

                    //console.log(res);
                    let saveCount = res.data;
                    this.loading = false;
                    this.$message.success(saveCount +'건 ' + this.$store.state.saveSuccess);
                    this.search();
                    // this.$refs.myFiles.files[0].name = null;
                }).catch(error => {
                    console.log(error.response)
                    this.$message.error(this.$store.state.serverErrorMessage);
                    this.currentPage = 1;
                    this.loading = false;
                }); // await Axios.post



            };
            reader.readAsBinaryString(file);

        },//filesChange

        Confirm(){
            // this.e.target.files[0].name = "";

            this.$refs.form.reset() ;
            this.dialogVisible = false;
            this.dialogVisible2 = false;
            this.search();

        },

        Confirm2(){
            // this.e.target.files[0].name = "";

            //console.log ("Confirm2") ;
            this.country = "";
            this.store = "";
            this.bigo="";
            this.dialogVisible2 = false;
            this.dialogVisible3 = false;
            this.search();

        },

        Confirm3(){
            // this.e.target.files[0].name = "";

            this.barcode2 = "";
            this.dialogVisible3 = false;

        },



        handleUpdate() {

            if (this.qrCount != this.selectedAmount)
            {
                this.playFailSound();
                this.$message.error(" 수량이 일치 하지 않습니다");
                return ;
            }

            if ( this.store.barcode2)
            {
                this.playFailSound();
                this.$message.error(" 바코드를 입력해주세요");
                return ;
            }

            if( this.letNo2 == null ||  this.letNo2.trim().length <= 0  )
            {
                this.playFailSound();
                this.$message.error(" 바코드를 입력해주세요");
                return ;
            }


            this.$confirm("수정 하시겠습니까?", "경고", {
                confirmButtonText: "수정",
                cancelButtonText: "취소",
                type: "warning",
                // 팝업 전체에 클래스를 입혀서 특정 팝업의 스타일만 바꿉니다.
                customClass: "delete-confirm-box",
            })
                .then(() => {
                    this.update();
                })
                .catch(() => {
                    console.log("취소");
                });
        },


        async update(){

            console.log("=====");
            console.log(this.insert_date_ktng );

            var array = this.barcode.split('\n');
            var resDataJson = [];

            if (!this.checkDuplicates(array))
            {

                return; // 중단
            }

            for ( var idx = 0 ; idx < array.length  ; idx++ ) {
                if (array[idx].startsWith('http') ) {
                    resDataJson.push({
                        auth_store_barcode_info_seq2 : this.auth_store_barcode_info_seq,
                        barcode: array[idx],
                        letNo : this.letNo2,
                        user_seq : 173,
                        insert_date_ktng : this.insert_date_ktng,
                        auth_store_info_seq : this.selectedItemStoreInfoSeq,
                        auth_store_barcode_info_seq : this.auth_store_barcode_info_seq[idx],
                    });
                }
            }
            let url = this.$url + '/authStoreBarcodeInfo/update2';

            Axios.post(url, resDataJson , this.$store.state.config  ).then(res => {

                //console.log(res );
                let saveCount = res.data;
                if (saveCount === 999999)
                {
                    this.playFailSound();
                    this.loading = false;
                    this.$message.error("동일한 BOX BARCODE 가 있습니다.");
                }else if (saveCount === 888888)
                {
                    this.playFailSound();
                    this.loading = false;
                    this.$message.error("동일한 QR CODE 가 있습니다.");
                }else {
                    this.playSuccessSound();
                    this.loading = false;
                    this.$message.success(saveCount + '건 ' + this.$store.state.saveSuccess);
                    this.dialogVisible3 = false;
                }
                // this.search();
                // this.dialogVisible2 = false;

                // this.search();
            }).catch(error => {
                console.log(error.response)
                this.playFailSound();
                this.$message.error(this.$store.state.serverErrorMessage);
                this.loading = false;
            }); // await Axios.post

        },


        async qrSave(){

            if (this.selectedItemStoreInfoSeq === null ||  this.selectedItemStoreInfoSeq === 0)
            {
                {
                    this.playFailSound();
                    this.$message.error("품목을 선택해 주세요");
                    return ;
                }
            }
            if (this.qrCount != this.selectedAmount)
            {
                this.playFailSound();
                this.$message.error(" 수량이 일치 하지 않습니다");
                return ;
            }

            var array = this.barcode.split('\n');

            var resDataJson = [];

            const rawLetNo = array.find(item => !item.startsWith('http'));


            if (!this.checkDuplicates(array))
            {
                return; // 중단
            }


// 수정된 부분:
// 1. 값이 없거나 (rawLetNo가 null/undefined/빈문자열인 경우)
// 2. 공백을 제거한 자릿수가 8 이하인 경우
            if (!rawLetNo || rawLetNo.trim().length <= 6) {
                // 필요하다면 여기서 사용자에게 알림을 띄울 수 있습니다.
                // 예: alert('유효한 박스 번호가 아닙니다.');
                this.playFailSound();
                this.$message.error("박스 번호가 없습니다. 저장을 중단합니다.");
                return; // 함수 종료 (중단)
            }

// 여기까지 코드가 도달했다면 letNo는 존재하고 9자리 이상입니다.
            const letNo = rawLetNo.trim(); // 깨끗한 값을 변수에 할당
            console.log("찾은 유효한 번호:", letNo);
            console.log("찾은 유효한 번호:", this.selectedItemStoreInfoSeq);


            for ( var idx = 0 ; idx < array.length  ; idx++ ) {
                if (array[idx].startsWith('http') ) {
                    resDataJson.push({
                        barcode: array[idx],
                        letNo : letNo,
                        user_seq: 173,
                        auth_store_info_seq : this.selectedItemStoreInfoSeq,
                    });
                }
            }

            let url = this.$url + '/authStoreBarcodeInfo/insert';
            Axios.post(url, resDataJson , this.$store.state.config  ).then(res => {

                //console.log(res );
                let saveCount = res.data;

                    if (saveCount === 999999)
                    {
                        this.loading = false;
                        this.playFailSound();
                        this.$message.error("동일한 BARCODE 가 있습니다.");
                    }else if (saveCount === 888888)
                    {
                        this.loading = false;
                        this.playFailSound();
                        this.$message.error("동일한 QR CODE 가 있습니다.");
                     }
                    else {
                        this.loading = false;
                        this.playSuccessSound();
                        this.$message.success(saveCount + '건 ' + this.$store.state.saveSuccess);
                        this.barcode = "";
                    }

                // this.search();
            }).catch(error => {
                console.log(error.response)
                this.playFailSound();
                this.$message.error(this.$store.state.serverErrorMessage);
                this.loading = false;
            }); // await Axios.post

        },


        submitUpload() {
            this.$refs.upload.submit();
        },

        async prepareFailSound() {
            try {
                const AudioContext = window.AudioContext || window.webkitAudioContext;
                if (!AudioContext) return null;

                if (!this.failAudioContext) {
                    this.failAudioContext = new AudioContext();
                }

                if (this.failAudioContext.state === "suspended") {
                    await this.failAudioContext.resume();
                }

                return this.failAudioContext;
            } catch (error) {
                console.log(error);
                return null;
            }
        },

        async playFailSound() {
            try {
                const audioContext = await this.prepareFailSound();
                if (!audioContext) return;

                const now = audioContext.currentTime;
                const oscillator = audioContext.createOscillator();
                const overTone = audioContext.createOscillator();
                const gainNode = audioContext.createGain();
                const overToneGain = audioContext.createGain();

                oscillator.type = "square";
                oscillator.frequency.setValueAtTime(980, now);
                oscillator.connect(gainNode);

                overTone.type = "sine";
                overTone.frequency.setValueAtTime(1960, now);
                overToneGain.gain.setValueAtTime(0.035, now);
                overTone.connect(overToneGain);
                overToneGain.connect(gainNode);

                gainNode.connect(audioContext.destination);

                gainNode.gain.setValueAtTime(0.0001, now);
                gainNode.gain.exponentialRampToValueAtTime(0.13, now + 0.006);
                gainNode.gain.setValueAtTime(0.13, now + 0.48);
                gainNode.gain.exponentialRampToValueAtTime(0.0001, now + 0.58);

                oscillator.start(now);
                overTone.start(now);
                oscillator.stop(now + 0.6);
                overTone.stop(now + 0.6);
            } catch (error) {
                console.log(error);
            }
        },

        async playSuccessSound() {
            try {
                const audioContext = await this.prepareFailSound();
                if (!audioContext) return;

                const now = audioContext.currentTime;
                const notes = [659.25, 880, 1174.66];

                notes.forEach((frequency, index) => {
                    const startTime = now + index * 0.2;
                    const endTime = startTime + 0.24;
                    const oscillator = audioContext.createOscillator();
                    const overTone = audioContext.createOscillator();
                    const gainNode = audioContext.createGain();
                    const overToneGain = audioContext.createGain();

                    oscillator.type = "triangle";
                    oscillator.frequency.setValueAtTime(frequency, startTime);
                    oscillator.connect(gainNode);

                    overTone.type = "sine";
                    overTone.frequency.setValueAtTime(frequency * 2, startTime);
                    overToneGain.gain.setValueAtTime(0.04, startTime);
                    overTone.connect(overToneGain);
                    overToneGain.connect(gainNode);

                    gainNode.connect(audioContext.destination);

                    gainNode.gain.setValueAtTime(0.0001, startTime);
                    gainNode.gain.exponentialRampToValueAtTime(0.20, startTime + 0.015);
                    gainNode.gain.exponentialRampToValueAtTime(0.08, startTime + 0.12);
                    gainNode.gain.exponentialRampToValueAtTime(0.0001, endTime);

                    oscillator.start(startTime);
                    overTone.start(startTime);
                    oscillator.stop(endTime);
                    overTone.stop(endTime);
                });
            } catch (error) {
                console.log(error);
            }
        },

        findDuplicateValue(array) {
            return this.findDuplicateInfo(array).value;
        },

        findDuplicateInfo(array) {
            const emptyResult = { value: "", count: 0 };
            if (!array || array.length === 0) return emptyResult;

            const FIXED_LENGTH = 42;
            const counts = new Map();
            let duplicateResult = emptyResult;

            for (const item of array) {
                const value = item ? item.trim() : "";
                if (!value) continue;
                if (!value.startsWith('http') || value.length !== FIXED_LENGTH) continue;

                const count = (counts.get(value) || 0) + 1;
                counts.set(value, count);

                if (count > 1 && count >= duplicateResult.count) {
                    duplicateResult = { value, count };
                }
            }

            return duplicateResult;
        },

        removeDuplicateLines(value) {
            const seen = new Set();
            const FIXED_LENGTH = 42;

            return value.split('\n').filter(line => {
                const trimmed = line.trim();
                if (!trimmed) return true;
                if (!trimmed.startsWith('http') || trimmed.length !== FIXED_LENGTH) return true;

                if (seen.has(trimmed)) {
                    return false;
                }

                seen.add(trimmed);
                return true;
            }).join('\n');
        },

        checkDuplicates(array) {
            console.log("checkDuplicates 시작");
            console.log(array);

            // 1. 수정된 부분: 배열이 아예 없거나 빈 배열일 때만 중복 없음(true)으로 반환
            if (!array || array.length === 0) return true;

            const duplicateValue = this.findDuplicateValue(array);

            if (duplicateValue) {
                console.log("중복 발견:", duplicateValue);
                this.playFailSound();
                this.$message.error(`중복된 값이 있습니다: ${duplicateValue}`);
                return false; // 중복 발견 시 즉시 중단
            }

            /*
            for (const [index, targetValue] of array.entries()) {
                // targetValue가 null이나 빈 문자열이면 체크 안 하고 싶을 경우 추가 조건 가능
                if (!targetValue) continue;

                const hasDuplicate = array.some((item, i) => i !== index && item === targetValue);

                if (hasDuplicate) {
                    console.log("중복 발견:", targetValue);
                    this.playFailSound();
                    this.$message.error(`중복된 값이 있습니다: ${targetValue}`);
                    return false; // 중복 발견 시 즉시 중단
                }
            }
            */

            return true; // 끝까지 돌았는데 중복 없으면 true
        },

        async excelDownFuncAll(){

            this.loading = true;

            // default data
            let url = this.$url + '/authStoreBarcodeInfo/getListForExcel2';
            var reqJson = new Object();
            var excepData=[];


            reqJson.in_start_date = this.confirmStartDateOption;
            reqJson.in_end_date = this.confirmEndDateOption;
            reqJson.country = this.countryInput;
            reqJson.letNo = this.letNoInput;
            reqJson.barcode = this.barcodeInput;
            reqJson.user_seq = 173;


            await Axios.post(url, reqJson , this.$store.state.config ).then(res => {
                var resDataJson = res.data.authStoreBarcodeInfoDTO;

                if (res.data.resultCode){

                    for (var resData in resDataJson) {

                        excepData.push({
                            일련번호 : resData  * 1 + 1
                            ,작업일자 : resDataJson[resData]['insert_date_ktng'].substring(0, 16)
                            ,품목 :  resDataJson[resData]['country']
                            ,BARCODE : resDataJson[resData]['letNo']
                            ,QRCODE :  resDataJson[resData]['barcode']
                        });


                    }

                }else{
                    this.$message.error(this.$store.state.dataNotFound);
                    this.loading = false;
                }
            }) // await Axios.post
                .catch(error => {
                    console.log(error.response)
                    this.$message.error(this.$store.state.serverErrorMessage);
                    this.currentPage = 1;
                    this.loading = false;
                }); // await Axios.post




            // var excepData = [];
            //
            // for (var i in this.tmpData) {
            //   excepData.push({
            //     일련번호 : this.totalData[i]['seq']
            //     ,작업일자 : this.totalData[i]['insert_date']
            //     ,대박스번호 : this.totalData[i]['big_qr_code']
            //     ,소박스매핑건수 : this.totalData[i]['total_count']
            //   });
            // }
            //
            // this.loading = true;
            var dataWS = XLSX.utils.json_to_sheet(excepData);
            var wb = XLSX.utils.book_new();
            // workbook에 워크시트 추가
            // 시트명은 'nameData'
            XLSX.utils.book_append_sheet(wb, dataWS, 'kt&g출고매핑');
            // 엑셀 파일을 내보낸다.
            this.$store.commit("dayBefore",0); // 오늘날짜
            XLSX.writeFile(wb, "kt&g출고매핑"+'.xlsx');
            this.loading = false;


        },//excelDownFunc


        handleDelete() {
            if (this.multipleSelection.length <= 0) {
                this.$notify.error({
                    title: "데이터를 선택하세요 ",
                    position: "bottom-right",
                    duration: 1500,
                });
                return;
            }

            this.$confirm("삭제 하시겠습니까?", "경고", {
                confirmButtonText: "삭제",
                cancelButtonText: "취소",
                type: "warning",
                // 팝업 전체에 클래스를 입혀서 특정 팝업의 스타일만 바꿉니다.
                customClass: "delete-confirm-box",
            })
                .then(() => {
                    this.remove();
                })
                .catch(() => {
                    console.log("취소");
                });
        },

        async remove(){
            if (this.multipleSelection.length <= 0)
            {
                this.$message.error("데이터를 선택하세요 ");
                return ;
            }
            this.loading = true;
            let url = "";
            url = this.$url + '/authStoreBarcodeInfo/removeLetNo';
            Axios.post(url, this.multipleSelection , this.$store.state.config  ).then(res => {

                //console.log(res );
                let saveCount = res.data;
                this.loading = false;
                this.$message.success(saveCount +'건 삭제 되었습니다.');
                this.search(false);

            }).catch(error => {
                console.log(error.response)
                this.$message.error(this.$store.state.serverErrorMessage);
                this.currentPage = 1;
                this.loading = false;
            }); // await Axios.post
        }, // remove



    }, //methods
}
</script>


<style>

.el-dialog__body {
    padding: 10px 20px !important;
}

.textarea_class {
    height: 300px !important;
}

.el-textarea__inner {

    height: 100% !important;

}



.searchBody_production {
    width: 100px !important;
    margin-left: 20px !important;
}

     /* 파란색 클래스 */
 .text-blue {
     color: #409EFF !important; /* Element UI 기본 파란색 */
 }

/* 빨간색 클래스 */
.text-red {
    color: #F56C6C !important; /* Element UI 기본 빨간색 */
}

.qr-count {
    font-size: 20px !important;
    font-weight: bold;
    transition: color 0.3s; /* 색상이 부드럽게 변하게 하려면 추가 */
}

.rounded-dialog {
    border-radius: 20px !important;
    overflow: hidden !important;
}

.box-mapping-dialog {
    height: 110vh !important;
    max-height: 110vh !important;
    display: flex;
    flex-direction: column;
}

.box-mapping-dialog .el-dialog__body {
    flex: 1;
    overflow: auto;
    padding: 16px 28px !important;
}

.box-mapping-dialog .textarea_class {
    height: calc(99vh - 275px) !important;
    min-height: 430px;
}

.box-mapping-dialog .textarea_class .el-textarea__inner {
    font-size: 21px !important;
    line-height: 1.5 !important;
}

.box-mapping-dialog .el-checkbox__label {
    font-size: 20px !important;
}

/* 상단 헤더 배경색이나 테두리가 라운드를 가린다면 이것도 추가 */
.rounded-dialog .el-dialog__header {
    border-top-left-radius: 20px;
    border-top-right-radius: 20px;
}

::v-deep .rounded-dialog {
    border-radius: 20px !important;
    overflow: hidden;
}

/* 1. 헤더 전체 패딩 조절 (글자가 안 잘리도록 안쪽으로 밀기) */
/* 1. 제목 글자 크기 키우고 밑으로 내리기 */
.rounded-dialog .el-dialog__title {
    font-size: 24px !important;    /* 글자 크기 대폭 확대 */
    font-weight: 800;             /* 더 두껍게 강조 */
    color: #2c3e50;
    display: inline-block;
    padding-top: 8px;             /* 글자를 아래로 살짝 밀어줌 */
}

/* 2. 'X' 버튼 위치도 제목의 중심에 맞춰 재조정 */
.rounded-dialog .el-dialog__headerbtn {
    /* 제목이 커지고 내려왔으므로 'X' 버튼도 같이 조금 내려줘야 수평이 맞습니다 */
    top: 32px !important;
    right: 25px !important;
}

/* 3. 헤더 전체 영역 여유분 확보 */
.rounded-dialog .el-dialog__header {
    padding: 30px 25px 15px !important; /* 상단 패딩을 더 늘려 공간 확보 */
}


.custom-select {
    /* 테두리 색상 및 라운드 조정 */
    --el-select-border-color-hover: #409eff;
    --el-select-input-focus-border-color: #67c23a;
    --el-border-radius-base: 8px; /* 둥근 모서리 */

    width: 240px;
}

/* 입력창 내부 배경색 변경 */
:deep(.el-input__wrapper) {
    background-color: #f5f7fa;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}


/* style 태그에 scoped가 있다면 반드시 :deep()을 써야 합니다 */
.blue-border-input :deep(.el-input__inner),
.blue-border-input :deep(.el-input__wrapper) {
    border: 1px solid #409EFF !important; /* 강제로 푸른색 테두리 부여 */
    box-shadow: none !important; /* 기본 그림자 제거 */
}

/* 포커스 시 테두리 색상이 바뀌는 걸 막으려면 */
.blue-border-input :deep(.el-input__wrapper.is-focus),
.blue-border-input :deep(.el-input__inner:focus) {
    border-color: #0056b3 !important;
    box-shadow: 0 0 0 1px #0056b3 inset !important;
}


/* 1. 기본 테두리 및 사이즈 고정 (클릭 시 커짐 방지) */
.custom-blue-select :deep(.el-input__inner),
.custom-blue-select :deep(.el-input__wrapper) {
    border: 1px solid #409EFF !important; /* 기본 푸른색 테두리 */
    box-shadow: none !important; /* 클릭 시 퍼지는 그림자 제거 (커져 보이는 원인) */
    width: 150px; /* 원하는 가로 너비 고정 */
}

/* 2. 클릭(포커스) 되었을 때도 크기 변화 없이 색상만 유지 */
.custom-blue-select :deep(.el-input.is-focus .el-input__wrapper),
.custom-blue-select :deep(.el-input__inner:focus) {
    border-color: #0056b3 !important;
    box-shadow: none !important;
}

/* 3. 오른쪽 화살표(아이콘) 디자인 변경 */
.custom-blue-select :deep(.el-input__suffix) {
    right: 5px; /* 화살표 위치 미세 조정 */
}

.custom-blue-select :deep(.el-select__caret) {
    color: #409EFF !important; /* 화살표 색상을 테두리와 맞춤 */
    font-size: 14px !important; /* 화살표 크기 조절 */
    font-weight: bold;
}

/* 4. 선택 창(드롭다운) 하단 위치 미세 조정 */
.el-select-dropdown {
    margin-top: 5px !important;
}
</style>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
//.el-select .el-input {
//  width: 410px !important;
//}

$teal: rgb(0, 124, 137);
.inputBarcode .el-input__inner:hover {
    border-color: $teal !important;
}
.inputBarcode .el-input input {
    padding-left: 35px !important;
}



/* 전역 스타일로 작성 (scoped 제거 권장) */
/* 1. 기본 박스 디자인: 테두리를 얇고 푸른색으로, 모서리는 둥글게 */
.alien-pretty-select.el-select .el-input__wrapper,
.alien-pretty-select.el-select .el-input__inner {
    background-color: #ffffff !important;
    border: 1px solid #dcdfe6 !important; /* 기본은 차분한 회색 */
    border-radius: 6px !important;
    transition: all 0.2s ease-in-out !important;
    box-shadow: none !important; /* 클릭 시 박스 커짐의 주범 제거 */
}

/* 2. 마우스 올렸을 때와 클릭(포커스)했을 때 */
.alien-pretty-select.el-select:hover .el-input__wrapper,
.alien-pretty-select.el-select .is-focus .el-input__wrapper {
    border-color: #409EFF !important; /* 에일리언 블루 포인트 */
    background-color: #f5f7fa !important;
}

/* 3. 화살표 아이콘 커스텀 (더 얇고 세련되게) */
.alien-pretty-select .el-select__caret {
    color: #409EFF !important;
    font-weight: bold !important;
    transform: rotateZ(0deg);
    transition: transform 0.3s !important;
}

/* 4. 클릭 시 박스가 "커지는" 느낌을 주는 테두리 확장 방지 */
.alien-pretty-select .el-input.is-focus .el-input__wrapper {
    box-shadow: 0 0 0 1px #409EFF inset !important; /* 겉으로 커지지 않고 안으로 강조 */
}

/* 5. 선택 리스트(드롭다운) 디자인 */
.el-select-dropdown__item.selected {
    color: #409EFF !important;
    font-weight: bold !important;
}



/* 1. 기본 상태와 포커스 상태의 물리적 크기를 동일하게 고정 */
.custom-blue-select.el-select .el-input__wrapper,
.custom-blue-select.el-select .el-input__inner {
    box-shadow: none !important; /* 외부로 퍼지는 그림자 제거 (크기 변화의 주범) */
    outline: none !important;    /* 브라우저 기본 포커스 선 제거 */
    border: 1px solid #dcdfe6 !important; /* 기본 테두리 두께 고정 */
    transition: border-color 0.2s !important; /* 색상만 부드럽게 변경 */
}

/* 2. 클릭(포커스) 시 크기는 유지하고 테두리 색상만 변경 */
.custom-blue-select.el-select .is-focus .el-input__wrapper,
.custom-blue-select.el-select .el-input__inner:focus {
    border-color: #409EFF !important; /* 테두리 색상만 강조 */
    box-shadow: none !important;      /* 강조 시에도 그림자 절대 금지 */

    /* 만약 더 강조하고 싶다면, 밖이 아닌 '안쪽'으로만 그림자 추가 */
    /* box-shadow: 0 0 0 1px #409EFF inset !important; */
}




/* 1. 버튼들을 감싸는 컨테이너를 가로 정렬(row)로 강제 */
.delete-confirm-box .el-message-box__btns {
    display: flex !important;
    flex-direction: row !important;      /* 가로로 나열 */
    justify-content: flex-end !important; /* 오른쪽 정렬 */
    padding-top: 10px !important;
}

/* 2. 각 버튼이 한 줄을 다 차지하지 않도록 너비 조정 */
.delete-confirm-box .el-message-box__btns .el-button {
    width: auto !important;   /* 혹은 적절한 너비(예: 70px) */
    margin-left: 10px !important; /* 버튼 사이 간격 */
    display: inline-flex !important; /* 버튼 내부 텍스트 정렬 유지 */
    justify-content: center !important;
}

/* 3. 취소 버튼과 확인 버튼의 순서가 바뀌어 보인다면 (필요 시 사용) */
/* Element UI 기본은 취소가 왼쪽(첫번째), 확인이 오른쪽(두번째)입니다. */
.delete-confirm-box .el-message-box__btns button:nth-child(1) {
    order: 1; /* 취소 버튼 */
}
.delete-confirm-box .el-message-box__btns button:nth-child(2) {
    order: 2; /* 확인 버튼 */
}
</style>
